import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import fileDownload from "js-file-download";
import Button from "../../../components/Button";
import DataTable from "../../../components/DataTable/DataTable";
import Select from "../../../components/Inputs/Select";
import {
  getObjectionsOrderMatchRequested,
  getObjectionsHistoryRequested,
  setObjectionsHistoryFilter,
} from "../../../redux/actions/objections";
import {
  convertNumberToFrontend,
  convertAmountToFrontend,
} from "../../../helpers/convert";
import Pill from "../../../components/Pill";
import moment from "moment";
import TitleValue from "../../../components/TitleValue";
import { Input, Textarea } from "../../../components/Inputs";
import Modal from "../../../components/Modal";
import { API_POST, API_GET, API_EXPORT } from "../../../helpers/api";
import { setNotification } from "../../../helpers/notification";
import ModalConfirmation from "../../../components/Modal/ModalConfirmation";
import Icon from "../../../components/Icon";
import { objectionStatus } from "../../../constants/translations";
import DataTableServerSideRendering from "../../../components/DataTable/DataTableServerSideRendering";

export default function Objections({ t }) {
  const dispatch = useDispatch();
  // const serverTime = useSelector((state) => state.utilities.serverTime);
  const serverTimeInitial = useSelector(
    (state) => state.utilities.serverTimeInitial
  );
  const organization = useSelector(
    (state) => state.authorization.user.organization
  );
  const authUser = useSelector((state) => state.authorization.user);

  const orderMatches = useSelector((state) => state.objections.orderMatches);

  const { data: objectionsHistory, total: objectTotal } = useSelector(
    (state) => state.objections.objectionsHistory
  );

  const objectionsHistoryFilter = useSelector(
    (state) => state.objections.objectionsHistoryFilter
  );
  const [objectionOffer, setObjectionOffer] = useState();

  const [objectionDescription, setObjectionDescription] = useState("");
  const [objectionConfirmationModal, setObjectionConfirmationModal] =
    useState(false);
  const [objectionRequestLoading, setObjectionRequestLoading] = useState(false);
  const [inspectedObjectionDetail, setInspectedObjectionDetail] = useState();

  const [objectionDetailModal, setObjectionDetailModal] = useState(false);
  const [objectionMinute, setObjectionMinute] = useState(20);
  const [activePage, setActivePage] = useState(0);
  const [sortedColumn, setSortedColumn] = useState("productionPeriod");
  const [sortDirection, setSortDirection] = useState("desc");
  const [exportLoading, setExportLoading] = useState(false);
  const translations = objectionStatus(t);

  const objectionStatusHandler = {
    INITIAL: {
      text: translations.INITIAL,
      color: "primary",
    },
    ACCEPTED: {
      text: translations.ACCEPTED,
      color: "success",
    },
    REJECTED: {
      text: translations.REJECTED,
      color: "important",
    },
  };

  const matchesColumns = [
    {
      name: t("pages.default.objections.contractName"),
      selector: "contractName",
      sortable: true,
    },
    {
      name: t("pages.default.objections.matchDate"),
      selector: "matchDate",
      sortable: true,
      cell: (row) => {
        return moment(row.matchDate).format("DD.MM.YYYY HH:mm:ss");
      },
    },
    {
      name: t("pages.default.objections.orderId"),
      selector: "orderId",
      sortable: true,
    },
    {
      name: t("pages.default.objections.offerAmount"),
      selector: "quantity",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.quantity);
      },
    },
    {
      name: t("pages.default.objections.orderPrice"),
      selector: "price",
      sortable: true,
      cell: (row) => {
        return convertNumberToFrontend({ num: row.price, digit: 2 });
      },
    },
    {
      name: t("pages.default.objections.matchAmount"),
      selector: "matchQuantity",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.matchQuantity);
      },
    },
    {
      name: t("pages.default.objections.matchPrice"),
      selector: "matchPrice",
      sortable: true,
      cell: (row) => {
        return convertNumberToFrontend({ num: row.matchPrice, digit: 2 });
      },
    },
    {
      name: t("pages.default.objections.process"),
      selector: "orderType",
      sortable: true,
      cell: (row) => {
        return (
          <span
            className={
              row.orderType === "BUY"
                ? "km__u--text-green-300"
                : "km__u--text-red-300"
            }
          >
            {row.orderType === "BUY"
              ? t("ui.default.offerTab.buy")
              : t("ui.default.offerTab.sell")}
          </span>
        );
      },
    },
    {
      name: t("pages.default.objections.action"),
      selector: "id",
      sortable: false,
      cell: (row) => {
        return (
          <div style={{ display: "flex" }}>
            <Button
              title={t("pages.default.objections.object")}
              type="destructive"
              label={t("pages.default.objections.object")}
              onClick={() => clickObjection(row)}
              disabled={
                !row.objectionAble
                // !(
                //   -moment(row.matchDate).diff(serverTime, "seconds") <=
                //   objectionMinute * 60
                // ) ||
                // checkAlreadyObjected(row) ||
                // row.matchStatus.value === "CANCELLED"
              }
            />
          </div>
        );
      },
    },
  ];

  const objectionsHistoryColumns = [
    {
      name: t("pages.default.objections.contractName"),
      selector: "contractName",
      sortable: true,
    },
    {
      name: t("pages.default.objections.orderId"),
      selector: "orderId",
      sortable: true,
    },
    {
      name: t("pages.default.objections.objectionTime"),
      selector: "objectionTime",
      sortable: true,
    },
    {
      name: t("pages.default.objections.objectionDescription"),
      selector: "objectionDescription",
      sortable: true,
    },
    {
      name: t("pages.default.objections.answer"),
      selector: "answer",
      sortable: true,
    },
    {
      name: t("pages.default.objections.statusText"),
      selector: "status",
      sortable: true,
      cell: (row) => {
        return (
          <Pill
            type={objectionStatusHandler[row.status].color}
            label={objectionStatusHandler[row.status].text}
          />
        );
      },
    },
    {
      name: t("pages.default.objections.process"),
      selector: "id",
      sortable: false,
      cell: (row) => {
        return (
          <div style={{ display: "flex" }}>
            <Button
              title={t("ui.default.review")}
              type="primary"
              suffixIcon="search"
              onClick={() => toggleObjectionDetail(row)}
            />
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(getObjectionsOrderMatchRequested(organization.organizationId));
    dispatch(
      getObjectionsHistoryRequested({
        ...objectionsHistoryFilter,
        status: "all",
        organization: organization,
      })
    );
    getObjectionMinute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // get matches, objections history and objection minute for every 5 sec
  useEffect(() => {
    const interval = setInterval(() => {
      getMatches();
      getObjectionsHistory();
      getObjectionMinute();
    }, 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objectionsHistoryFilter]);

  const getMatches = () => {
    dispatch(getObjectionsOrderMatchRequested(organization.organizationId));
  };

  const getObjectionMinute = async () => {
    let res = await API_GET("system-parameter/parameter");
    let OBJECTION_MINUTE = res.data.find((item) => {
      return item.parameterName === "objection_period";
    });
    setObjectionMinute(OBJECTION_MINUTE.parameterValue);
  };

  // trigger get requests
  const getObjectionsHistory = () => {
    dispatch(
      getObjectionsHistoryRequested({
        ...objectionsHistoryFilter,
        status:
          objectionsHistoryFilter.status === "-"
            ? "all"
            : objectionsHistoryFilter.status,
        organization: organization,
      })
    );
  };

  // filters
  const startDateChange = (e) => {
    dispatch(
      setObjectionsHistoryFilter({ type: "startDate", value: e.target.value })
    );
  };
  const endDateChange = (e) => {
    dispatch(
      setObjectionsHistoryFilter({ type: "endDate", value: e.target.value })
    );
  };
  const statusChange = (e) => {
    dispatch(
      setObjectionsHistoryFilter({ type: "status", value: e.target.value })
    );
  };
  // objection answer detail
  const toggleObjectionDetail = (row) => {
    setInspectedObjectionDetail(row);
    setObjectionDetailModal(true);
  };

  const closeObjectionDetailModal = () => {
    setObjectionDetailModal(false);
    setInspectedObjectionDetail();
  };

  // send objection
  const clickObjection = (row) => {
    if (
      -moment(row.matchDate).diff(serverTimeInitial, "minutes") <=
      objectionMinute
    ) {
      setObjectionOffer(row);
      return;
    }
    setNotification("error", t("pages.default.objections.errors.timeout"));
  };

  const objectionDescriptionChange = (e) => {
    setObjectionDescription(e.target.value);
  };

  const validateObjectionRequest = () => {
    if (!objectionDescription) {
      setNotification(
        "error",
        t("pages.default.objections.errors.descriptionNotFound")
      );
      return false;
    }
    if (objectionDescription.length < 10) {
      setNotification(
        "error",
        t("pages.default.objections.errors.descriptionMinCharacter")
      );
      return false;
    }
    return true;
  };

  const objectionConfirmationToggle = () => {
    if (!validateObjectionRequest()) {
      return false;
    }
    setObjectionConfirmationModal(true);
  };

  const objectionRequest = async () => {
    if (!validateObjectionRequest()) {
      return false;
    }
    try {
      setObjectionRequestLoading(true);
      await API_POST("objections", {
        bundleId: objectionOffer.id,
        organizationId: organization.organizationId,
        note: objectionDescription,
      });
      setNotification("success", t("pages.default.objections.success.object"));
      setObjectionOffer();
      setObjectionDescription("");
      setObjectionRequestLoading(false);
      setObjectionConfirmationModal(false);
      getMatches();
      getObjectionsHistory();
    } catch (err) {
      setNotification("error", err.response.data.message);
      setObjectionRequestLoading(false);
    }
  };

  const downloadCommitmentStatus = async () => {
    setExportLoading(true);
    try {
      const res = await API_EXPORT("/objection/export/excel", {
        organizationId: organization ? organization?.organizationId : null,
        objectionStatus:
          objectionsHistoryFilter?.status === "-" ||
          objectionsHistoryFilter?.status === "all"
            ? ""
            : objectionsHistoryFilter?.status,
        startDate:
          moment(objectionsHistoryFilter?.startDate).format("YYYYMMDD") ?? null,
        endDate:
          moment(objectionsHistoryFilter?.endDate).format("YYYYMMDD") ?? null,
        lang: window.localStorage.i18nextLng,
      });
      const [, filename] =
        res?.headers["content-disposition"].split("filename=");
      fileDownload(res.data, filename);
      setExportLoading(false);
      setNotification("success", t("ui.default.downloaded"));
    } catch (err) {
      err.response && setNotification("error", err.response.data.message);
      setExportLoading(false);
    }
  };

  const checkAlreadyObjected = (row) => {
    if (row.buyOrder) {
      if (row.buyOrder.organizationId === organization.organizationId)
        return row.buyerObjected;
      if (row.sellOrder.organizationId === organization.organizationId)
        return row.sellerObjected;
    }
  };

  const handleClick = (activePage, selector, direction) => {
    console.log("page", activePage, selector, direction);
    setActivePage(activePage);
    dispatch(
      dispatch(
        getObjectionsHistoryRequested({
          page: activePage,
          selector,
          direction,
        })
      )
    );
  };

  return (
    <>
      <h5 className="km__u--text-has-emphasis">
        {t("pages.default.objections.object")}
      </h5>
      {authUser.organization.yekgOrganizationStatus === "PASSIVE" ||
      authUser.organization.yekgOrganizationStatus === "PARTIAL_PASSIVE" ? (
        ""
      ) : (
        <div className="km__p--card">
          <div className="km__p--objections-filter-container">
            <div className="km__p--objections-title">
              {t("pages.default.objections.objectOperations")}
            </div>
          </div>

          <DataTable
            columns={matchesColumns}
            data={orderMatches}
            pagination
            paginationPerPage={15}
          />
        </div>
      )}

      <div className="km__p--card">
        <div className="km__p--objections-filter-container">
          <div className="km__p--objections-title">
            {t("pages.default.objections.title")}
          </div>
          <div className="km__p--objections-filters">
            <Input
              type="date"
              placeholder={t(
                "pages.default.bilateralAgreements.input.startDate"
              )}
              max={objectionsHistoryFilter.endDate}
              value={objectionsHistoryFilter.startDate}
              onChange={startDateChange}
            />
            <Input
              type="date"
              placeholder={t("pages.default.bilateralAgreements.input.endDate")}
              min={objectionsHistoryFilter.startDate}
              value={objectionsHistoryFilter.endDate}
              onChange={endDateChange}
            />
            <Select
              defaultValue={objectionsHistoryFilter.status}
              options={[
                {
                  value: "all",
                  name: t("pages.default.certificates.filters.allStatus"),
                },
                { value: "INITIAL", name: translations.INITIAL },
                { value: "ACCEPTED", name: translations.ACCEPTED },
                { value: "REJECTED", name: translations.REJECTED },
              ]}
              onChange={statusChange}
            />
            <Button
              type="primary"
              label={t("ui.default.filter")}
              onClick={getObjectionsHistory}
            />
            <Button
              type="secondary"
              label={t("ui.default.download")}
              suffixIcon="download"
              onClick={downloadCommitmentStatus}
              disabled={exportLoading}
              id="c-download"
            />
          </div>
        </div>
        <DataTableServerSideRendering
          columns={objectionsHistoryColumns}
          data={objectionsHistory}
          rowKey="id"
          sortedColumn={sortedColumn}
          setSortedColumn={setSortedColumn}
          sortDirection={sortDirection}
          setSortDirection={setSortDirection}
          pagination
          activePage={activePage}
          totalPageCount={objectTotal?.totalPageCount}
          handleFetchData={handleClick}
        />
      </div>
      {objectionOffer && (
        <Modal
          isOpen={objectionOffer ? true : false}
          toggle={() => setObjectionOffer()}
        >
          <div className="km__p--objection-modal-title">
            {t("pages.default.objections.doObject")}
            <div className="km__p--objection-modal-close">
              <Icon name="x" size="16" onClick={() => setObjectionOffer()} />
            </div>
          </div>
          <div className="km__p--objection-post-modal-detail">
            <div className="km__p--objection-post-modal-detail-column">
              <TitleValue
                title={t("pages.default.objections.modal.organization")}
                value={objectionOffer.organizationName}
                size="lg"
              />
              <TitleValue
                size="lg"
                title={t("pages.default.objections.modal.orderId")}
                value={objectionOffer.orderId}
              />
              <TitleValue
                size="lg"
                title={t("pages.default.objections.modal.orderDate")}
                value={moment(objectionOffer.offerDate).format(
                  "DD.MM.YYYY HH:mm:ss"
                )}
              />
              <TitleValue
                size="lg"
                title={t("pages.default.objections.modal.matchDate")}
                value={moment(objectionOffer.matchDate).format(
                  "DD.MM.YYYY HH:mm:ss"
                )}
              />
            </div>
            <div className="km__p--objection-post-modal-detail-column">
              <TitleValue
                title={t("pages.default.objections.modal.userName")}
                value={objectionOffer.userName}
                size="lg"
              />
              <TitleValue
                size="lg"
                title={t("pages.default.objections.modal.orderPrice")}
                value={`${convertNumberToFrontend({
                  num: objectionOffer.price,
                  digit: 2,
                })} ₺`}
              />
              <TitleValue
                size="lg"
                title={t("pages.default.objections.modal.orderAmount")}
                value={convertAmountToFrontend(objectionOffer.quantity)}
              />
              <TitleValue
                size="lg"
                title={t("pages.default.objections.modal.matchPrice")}
                value={`${convertNumberToFrontend({
                  num: objectionOffer.matchPrice,
                  digit: 2,
                })} ₺`}
              />
              <TitleValue
                size="lg"
                title={t("pages.default.objections.modal.matchAmount")}
                value={convertAmountToFrontend(objectionOffer.matchQuantity)}
              />
            </div>
          </div>
          <div className="km__p--objection-post-modal-input">
            <Textarea
              label={t("pages.default.objections.modal.note")}
              defaultValue={objectionDescription}
              onChange={objectionDescriptionChange}
              value={objectionDescription}
            />
          </div>
          <div className="km__p--objection-post-modal-footer">
            <Button
              label={t("ui.default.discard")}
              type="secondary"
              onClick={() => setObjectionOffer()}
            />
            <Button
              label={t("pages.default.objections.doObject")}
              type="primary"
              onClick={() => objectionConfirmationToggle()}
            />
          </div>
        </Modal>
      )}
      {inspectedObjectionDetail && (
        <Modal isOpen={objectionDetailModal} toggle={closeObjectionDetailModal}>
          <div className="km__p--objection-modal-title">
            {t("pages.default.objections.viewObjection")}
            <div className="km__p--objection-modal-close">
              <Icon name="x" size="16" onClick={closeObjectionDetailModal} />
            </div>
          </div>
          <div className="km__p--objection-modal-row">
            <div className="km__p--objection-modal-column">
              <TitleValue
                title={t("pages.default.objections.modal.organization")}
                value={inspectedObjectionDetail.organizationName}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.userName")}
                value={inspectedObjectionDetail.userName}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.orderId")}
                value={inspectedObjectionDetail.orderId}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.orderTime")}
                value={inspectedObjectionDetail.orderTime}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.matchDate")}
                value={inspectedObjectionDetail.matchTime}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.objectionTime")}
                value={inspectedObjectionDetail.objectionTime}
                size="lg"
              />
              {inspectedObjectionDetail.status !== "INITIAL" && (
                <>
                  <TitleValue
                    title={t("pages.default.objections.modal.answerBy")}
                    value={inspectedObjectionDetail.answeredBy}
                    size="lg"
                  />
                  <TitleValue
                    title={t("pages.default.objections.modal.answerTime")}
                    value={inspectedObjectionDetail.answeredAt}
                    size="lg"
                  />
                </>
              )}
            </div>
            <div className="km__p--objection-modal-column">
              <TitleValue
                title={t("pages.default.objections.modal.orderPrice")}
                value={`${convertNumberToFrontend({
                  num: inspectedObjectionDetail.orderPrice,
                  digit: 2,
                })} ₺`}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.orderAmount")}
                value={convertAmountToFrontend(
                  inspectedObjectionDetail?.quantity
                )}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.matchPrice")}
                value={`${convertNumberToFrontend({
                  num: inspectedObjectionDetail.matchPrice,
                  digit: 2,
                })} ₺`}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.matchAmount")}
                value={convertAmountToFrontend(
                  inspectedObjectionDetail.orderTotalBuyAmount
                )}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.userEmail")}
                value={inspectedObjectionDetail.userEmail}
                size="lg"
              />
              <TitleValue
                title={t("pages.default.objections.modal.userTel")}
                value={
                  inspectedObjectionDetail.details.userTel !== null
                    ? inspectedObjectionDetail.details.userTel
                    : "-"
                }
                size="lg"
              />
            </div>
          </div>
          <div className="km__p--objection-modal-row">
            <Textarea
              label={t("pages.default.objections.modal.note")}
              defaultValue={inspectedObjectionDetail.details.note}
              disabled
            />
          </div>
          {inspectedObjectionDetail.status !== "INITIAL" && (
            <div className="km__p--objection-modal-row">
              <Textarea
                label={t("pages.default.objections.modal.answer")}
                name="answer"
                value={inspectedObjectionDetail.answer}
                disabled
              />
            </div>
          )}
          {inspectedObjectionDetail.status !== "INITIAL" && (
            <div className="km__p--objection-modal-row">
              <Select
                label={t("pages.default.objections.modal.result")}
                name="objectionStatus"
                value={inspectedObjectionDetail.status}
                disabled
                options={[
                  { name: translations.INITIAL, value: "INITIAL" },
                  { name: translations.ACCEPTED, value: "ACCEPTED" },
                  { name: translations.REJECTED, value: "REJECTED" },
                ]}
              />
            </div>
          )}
        </Modal>
      )}
      <ModalConfirmation
        toggle={() => setObjectionConfirmationModal(false)}
        isOpen={objectionConfirmationModal}
        header={t("pages.default.objections.confirmation.object.title")}
        body={t("pages.default.objections.confirmation.object.description")}
        approve={objectionRequest}
        loading={objectionRequestLoading}
      />
    </>
  );
}
